import { JSONUtils } from '../../../utility/json-utils.js';
import { MapUtils } from '../../../utility/map-utils.js';
import {
  cloneData, cloneList, isSameList,
} from '../../dto/data-model-utils.js';
import { SerializedData } from '../../dto/data-model.js';
import { Vec2 } from '../../math/vec2.js';
import { SeatingElement } from './seating-element.js';

export class StandingArea extends SeatingElement {
  static readonly TYPE_ID: number = 0x05;

  constructor(
      uniqueId: number,
      enabled: boolean,
      position: Vec2,
      rotation: number,
      public readonly width: number,
      public readonly height: number,
      public readonly tickets: string[],
      parent: WeakRef<SeatingElement> | null = null,
  ) {
    super(uniqueId, enabled, position, rotation, parent);
  }

  get $typeId(): number {
    return StandingArea.TYPE_ID;
  }

  static fromJson(data: SerializedData): StandingArea {
    return new StandingArea(
        MapUtils.getInteger(data, 'uniqueId'),
        MapUtils.getBoolean(data, 'enabled'),
        Vec2.fromJson(MapUtils.getRecord(data, 'position')),
        MapUtils.getDouble(data, 'rotation'),
        MapUtils.getDouble(data, 'width'),
        MapUtils.getDouble(data, 'height'),
        MapUtils.getList(data, 'tickets', (x) => JSONUtils.decodeString(x)),
    );
  }

  toJson(): SerializedData {
    return {
      $typeId: this.$typeId,
      uniqueId: this.uniqueId,
      enabled: this.enabled,
      position: this.position.toJson(),
      rotation: this.rotation,
      width: this.width,
      height: this.height,
      tickets: cloneList(this.tickets),
    };
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.uniqueId === this.uniqueId &&
        other.enabled === this.enabled &&
        other.position.isSame(this.position) &&
        other.rotation === this.rotation &&
        isSameList(other.tickets, this.tickets);
  }

  clone(parent: WeakRef<SeatingElement> | null): this {
    return new StandingArea(
        this.uniqueId,
        this.enabled,
        cloneData(this.position),
        this.rotation,
        this.width,
        this.height,
        cloneList(this.tickets),
        parent,
    ) as this;
  }
}
